import { defineMessages } from 'react-intl'

const scope = 'platform.banking.featureSets.financialAccountStatementDownload'

export default defineMessages({
  statementsButtonText: {
    id: `${scope}.statementsButtonText`,
    defaultMessage: 'Statements',
  },
  modalHeaderText: {
    id: `${scope}.modalHeaderText`,
    defaultMessage: 'Download statements',
  },
  statementSelectLabel: {
    id: `${scope}.statementSelectLabel`,
    defaultMessage: 'Statement month',
  },
  cancelButtonText: {
    id: `${scope}.cancelButtonText`,
    defaultMessage: 'Cancel',
  },
})
